<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icongangwei1"></i>
      实习岗位详情
    </div>
    <div class="padding-bottom-sm">
      <jobDetail :id="id"/>
    </div>
  </div>
</template>

<script>

import jobDetail from "@/components/jobDetail";
export default {
  name: "practiceBaseEdit",
  data() {
    return {
      id: 0,
    }
  },
  created() {
    this.$emit(
        "setIndex",
        '/fuse/practiceBase',
        "当前位置：实习管理 > 实习岗位详情",
        true
    );
    this.id = this.$route.query.id
  },
  components:{jobDetail},
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>